import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { NA_VALUE } from '@yme/common/constants';
import { getProductValueByOption, setFilterOptions } from '@yme/pdp-components/ProductCard';
import { getProductVariantsByColorWithGroupingProducts } from '@yme/selectors/products';
import { getMotoScootersValues } from '../helpers';
import { PRODUCT_OPTION_KEY } from './constants';
import { buildRadioButtonsOptionsList, getAvailableSkuByProductOptionValue, sortByMasterVariations, } from './helpers';
export const useCommonProductOptions = ({ productFilterOptions, variantsOfProduct, isRadioButtons = false, isMasterVariationSorting = false, }) => {
    const productOptionsValues = useSelector(getProductValueByOption(PRODUCT_OPTION_KEY));
    const productVariantsByColor = useSelector(getProductVariantsByColorWithGroupingProducts);
    const dispatch = useDispatch();
    const history = useHistory();
    const { sku, productOption = '', colorItemIndex = 0 } = productFilterOptions;
    const onSelectNewValue = useCallback((value) => {
        if (value && productOption !== value) {
            const currentVariant = getAvailableSkuByProductOptionValue({
                colorVariants: variantsOfProduct,
                productOption: value,
            });
            if (currentVariant && currentVariant.sku !== sku) {
                dispatch(setFilterOptions({
                    // set main prop
                    productOption: currentVariant.productOption || value,
                    // set relative options
                    sku: currentVariant.sku,
                }));
                history.push({
                    hash: currentVariant.sku,
                });
            }
        }
    }, [dispatch, history, productOption, sku, variantsOfProduct]);
    const isCurrentFilterExist = Boolean(productOptionsValues && productOptionsValues?.length);
    const isProductOptionsFilterExist = productOption && isCurrentFilterExist && productOption !== NA_VALUE;
    const commonReturnedProps = {
        onSelectNewValue,
        isProductOptionsFilterExist,
        productOption,
    };
    if (isProductOptionsFilterExist) {
        const defaultPossibleOptions = (productVariantsByColor && productVariantsByColor[colorItemIndex]?.productsPossibleOptions) ||
            [];
        if (isRadioButtons) {
            const allVariants = getMotoScootersValues(productOptionsValues);
            const possibleOptions = getMotoScootersValues(defaultPossibleOptions);
            return {
                ...commonReturnedProps,
                allVariants: isMasterVariationSorting
                    ? sortByMasterVariations(productVariantsByColor, allVariants)
                    : allVariants,
                possibleOptions,
            };
        }
        else {
            const possibleOptions = defaultPossibleOptions;
            const allVariants = buildRadioButtonsOptionsList(productOptionsValues);
            return {
                ...commonReturnedProps,
                allVariants: isMasterVariationSorting
                    ? sortByMasterVariations(productVariantsByColor, allVariants)
                    : allVariants,
                possibleOptions,
            };
        }
    }
    return {
        ...commonReturnedProps,
        possibleOptions: [],
        allVariants: [],
    };
};
